import React, { useState } from 'react';
import { Box } from '@mui/material';
import { PrintableTextField } from '../GeneralTextField';
import { IInterestsTheme } from '../../interfaces/Theme.interface';
import { Mode } from '../../interfaces/Mode.interface';
import { useMode } from '../../context/Mode.context';
import InterestsForm from '../builder/forms/InterestsForm';

interface InterestProps {
    cvId: number;
    interests: string | null;
    theme: IInterestsTheme;
}

const Interests: React.FC<InterestProps> = (props: InterestProps) => {
    const { mode } = useMode();
    const [interests] = useState<string | null>(props.interests);

    const isEditing: boolean = mode === Mode.EDIT;

    return (
        <Box id="interests" sx={{ mb: `${props.theme.margin.bottom}px` }}>
            {isEditing ? (
                <InterestsForm {...props} />
            ) : (
                <PrintableTextField value={interests ?? ''} typographyComponent={'p'} fontTheme={props.theme.font} />
            )}
        </Box>
    );
};

export default Interests;
